import { createModule } from '../../createModule';
export const createTxReportingAPI = createModule(({ http }) => ({
    /**
     * Get the tx report for a given date
     */
    getReport: async (params) => {
        const res = await http.get(`/v2/tx-reporting/report`, {
            params,
        });
        return res;
    },
    /**
     * Update a row in the tx report table.
     */
    updateReport: async (params) => {
        const res = await http.patch(`/v2/tx-reporting/report`, { body: params });
        return res;
    },
    /**
     * Send yourself an email of the tx report for a given date.
     */
    sendEmail: async (params) => {
        const res = await http.post(`/v2/tx-reporting/email`, { body: params });
        return res;
    },
    /**
     * Reset a row in the tx report table.
     */
    resetRow: async (params) => {
        const res = await http.post(`/v2/tx-reporting/reset`, { body: params });
        return res;
    },
}));
